import { TenantDtoStoreModel } from '@domain/tenant/tenant.models';

import { isDefined } from '@shared/utils/is-defined';

export const reconcileSelectedTenantId = (
  tenants: TenantDtoStoreModel[],
  selectedTenantId: string | undefined,
  persistedTenantId: string | undefined
): string | undefined => {
  if (isDefined(selectedTenantId) && tenants.some((tenant) => tenant.id === selectedTenantId)) {
    return selectedTenantId;
  }

  if (isDefined(persistedTenantId) && tenants.some((tenant) => tenant.id === persistedTenantId)) {
    return persistedTenantId;
  }

  return tenants[0]?.id;
};
